let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ghD2u")).then(() => parcelRequire('01pGG'));